import { PermissionMapping } from '@@/lib/permissions';

export type CentenePermission =
  | 'reader'
  | 'writer'
  | 'prompts-approver'
  | 'queue-approver'
  | 'transfer-approver'
  | 'bulk-write'
  | 'bulk-prompt-approve'
  | 'bulk-queue-availability-approve'
  | 'bulk-transfer-point-approve'
  | 'hoops-write';

const centenePermissionMapping: PermissionMapping<CentenePermission>[] = [
  {
    permissionSetMapping: {
      reader: [
        'centene-admin',
        'centene-business-upper',
        'centene-business-limited',
        'centene-read-only',
        'centene-hoops'
      ],
      writer: ['centene-admin', 'centene-business-upper', 'centene-business-limited', 'centene-business-limited'],
      'bulk-write': ['centene-bulk']
    },
    urlSignature: '/queue-availability',
    showInNavbar: true,
    label: 'Queue Availability'
  },
  {
    permissionSetMapping: {
      reader: ['centene-admin', 'centene-business-upper', 'centene-business-limited', 'centene-read-only'],
      writer: ['centene-admin', 'centene-business-upper', 'centene-business-limited', 'centene-business-limited'],
      'hoops-write': ['centene-hoops']
    },
    urlSignature: '/queue-availability/*',
    showInNavbar: false
  },
  {
    permissionSetMapping: {
      reader: [
        'centene-admin',
        'centene-business-upper',
        'centene-business-limited',
        'centene-read-only',
        'centene-hoops'
      ],
      writer: ['centene-admin', 'centene-business-upper', 'centene-business-limited'],
      'bulk-write': ['centene-bulk']
    },
    urlSignature: '/transfer-points',
    showInNavbar: true,
    label: 'Transfer Points'
  },
  {
    permissionSetMapping: {
      reader: ['centene-admin', 'centene-business-upper', 'centene-business-limited', 'centene-read-only'],
      writer: ['centene-admin', 'centene-business-upper', 'centene-business-limited'],
      'hoops-write': ['centene-hoops']
    },
    urlSignature: '/transfer-points/*',
    showInNavbar: false
  },
  {
    permissionSetMapping: {
      reader: [
        'centene-admin',
        'centene-business-upper',
        'centene-business-limited',
        'centene-read-only',
        'centene-prompts'
      ],
      writer: ['centene-admin', 'centene-business-upper', 'centene-business-limited'],
      'bulk-write': ['centene-bulk']
    },
    urlSignature: '/prompts',
    showInNavbar: true,
    label: 'Prompts'
  },
  {
    permissionSetMapping: {
      reader: [
        'centene-admin',
        'centene-business-upper',
        'centene-business-limited',
        'centene-read-only',
        'centene-prompts'
      ],
      writer: ['centene-admin', 'centene-business-upper', 'centene-business-limited', 'centene-prompts']
    },
    urlSignature: '/prompts/*',
    showInNavbar: false
  },
  {
    permissionSetMapping: {
      reader: [
        'centene-admin',
        'centene-business-upper',
        'centene-business-limited',
        'centene-read-only',
        'centene-prompts'
      ]
    },
    urlSignature: '/prompt-lookup',
    showInNavbar: true,
    label: 'Prompt Lookup'
  },
  {
    permissionSetMapping: {
      reader: [
        'centene-admin',
        'centene-business-upper',
        'centene-business-limited',
        'centene-prompts-approver',
        'centene-queue-approver',
        'centene-transfer-approver',
        'centene-prompts'
      ],
      writer: ['centene-admin', 'centene-business-upper'],
      'prompts-approver': ['centene-admin', 'centene-business-upper', 'centene-prompt-approver'],
      'queue-approver': ['centene-admin', 'centene-business-upper', 'centene-queue-approver'],
      'transfer-approver': ['centene-admin', 'centene-business-upper', 'centene-transfer-approver'],
      'bulk-transfer-point-approve': ['centene-transfer-approver'],
      'bulk-queue-availability-approve': ['centene-queue-approver'],
      'bulk-prompt-approve': ['centene-prompt-approver']
    },
    urlSignature: '/change-requests',
    showInNavbar: true,
    label: 'Change Requests'
  },
  {
    permissionSetMapping: {
      reader: ['centene-admin', 'centene-business-upper'],
      writer: ['centene-admin']
    },
    urlSignature: '/audit-log',
    showInNavbar: true,
    label: 'Audit Log'
  }
];

export default centenePermissionMapping;
